import { render, staticRenderFns } from "./article-list.vue?vue&type=template&id=43f272b0&scoped=true"
import script from "./article-list.vue?vue&type=script&lang=js"
export * from "./article-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f272b0",
  null
  
)

export default component.exports